import React from 'react';
import { Modal, Dropdown } from 'semantic-ui-react';

const BulkUpdateRoundStatusModal = ({
  isBulkUpdateModalOpen,
  setIsBulkUpdateModalOpen,
  selectedJobApplications,
  bulkUpdateStatusOptions,
  bulkRoundStatus,
  setBulkRoundStatus,
  bulkUpdateStatus,
}) => {
  return (
    <Modal
      onClose={() => setIsBulkUpdateModalOpen(false)}
      onOpen={() => setIsBulkUpdateModalOpen(true)}
      open={isBulkUpdateModalOpen}
    >
      <Modal.Header>Bulk Update Round Status</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <p>
            Note: This action will update the status of{' '}
            {selectedJobApplications.length} candidates to{' '}
          </p>
          <div className='w-1/4 px-4 py-3 leading-tight text-gray-700 border border-gray-200 rounded focus:outline-none focus:bg-white focus:border-gray-500 my-25 '>
            <Dropdown
              fluid
              options={bulkUpdateStatusOptions}
              placeholder='Current Round Status'
              onChange={(e, { value }) => {
                setBulkRoundStatus(value);
              }}
              value={bulkRoundStatus ?? 'interview'}
            />
          </div>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <button
          onClick={(e) => {
            e.preventDefault();
            setIsBulkUpdateModalOpen(false);
          }}
          className='px-8 py-2 ml-8 text-base font-medium border rounded text-gray border-primary-400'
        >
          Cancel
        </button>
        <button
          onClick={(e) => {
            e.preventDefault();
            bulkUpdateStatus();
          }}
          className='px-8 py-2 ml-8 text-base font-medium text-white border rounded bg-brand-primary border-primary-400'
        >
          Update
        </button>
      </Modal.Actions>
    </Modal>
  );
};

export default BulkUpdateRoundStatusModal;
